module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": _vm.closeDayView
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.previousWeek
    }
  }, [_c('v-icon', [_vm._v("first_page")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.previousDay
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.nextDay
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.nextWeek
    }
  }, [_c('v-icon', [_vm._v("last_page")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.today
    }
  }, [_c('v-icon', [_vm._v("today")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    ref: "dateMenu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    model: {
      value: (_vm.dateDialog),
      callback: function($$v) {
        _vm.dateDialog = $$v
      },
      expression: "dateDialog"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "prepend-inner-icon": "event",
      "solo-inverted": "",
      "flat": "",
      "color": "white",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateFmt),
      callback: function($$v) {
        _vm.dateFmt = $$v
      },
      expression: "dateFmt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        return _vm.saveDate(_vm.date)
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.gettingEvents) ? _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 70,
      "width": 10,
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : (_vm.fcEvents.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.fcEvents), function(job, index) {
    return _c('v-list-group', {
      key: index
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator",
        "avatar": ""
      },
      slot: "activator"
    }, [_c('v-list-tile-avatar', [_c('v-badge', {
      attrs: {
        "right": "",
        "overlap": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "large": ""
      }
    }, [_vm._v("assignment")]), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "badge",
        "small": ""
      },
      slot: "badge"
    }, [_vm._v(_vm._s(job.templates.length))])], 1)], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(job.JobNo))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s('Vehicle - ' + job.vehReg))])], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs11": "",
        "offset-xs1": ""
      }
    }, [_c('v-list', [_c('v-list-tile', [_c('v-list-tile-content', [_c('span', [_vm._v(_vm._s('Engineer: ' + _vm.engineerName(job.engineer)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s('Customer: ' + _vm.customers[job.Customer]))])])], 1)], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "dense": "",
        "dark": ""
      }
    }, _vm._l((job.templates), function(template, templateIndex) {
      return _c('v-list-tile', {
        key: templateIndex
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.templateName(template)))])], 1)], 1)
    }), 1)], 1)], 1)], 1)
  }), 1)], 1) : _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v("No jobs found for this day")])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c38df8d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DayView.vue
// module id = 765
// module chunks = 1